


import React, { useRef } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";


const ExperinecePage = () => {

    return (
        <Box>
            <Container style={{ maxWidth: "1400px" }}>
                <Typography  variant="h4" textAlign={"center"} sx={styles.title}>
                    Streamline Your Experience with <span style={{ color: "#535353" }} className="count-shine">GX Tickets</span>
                </Typography>

                <Box sx={{ mt: 10 }}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={8} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <img src="images/experience-img.svg" alt="exp-img" style={{ maxWidth: "100%", height: "auto" }} />
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default ExperinecePage;

const styles = {
    title: {
        fontWeight: 700,
        // fontSize: { xs: "2rem", md: "2.5rem" },
        fontSize: { xs: 24, sm: 32, md: 40 }
    },
};